import React from 'react';
const INK = '#01332b';
const SKIN = '#FBF7F0';
const TEAL = '#0D6B57';
interface FigureProps {
  className?: string;
}
export function OnlyChildFigure({
  className = ''
}: FigureProps) {
  return <svg viewBox="0 0 120 148" className={className} role="img" aria-label="Stylised illustration of an independent, self-assured only child" data-id="element-43" data-mp="3bq4xtg3ysbw0">
      {/* self-contained ring */}
      <circle cx="60" cy="74" r="50" fill="none" stroke={TEAL} strokeWidth="3" strokeDasharray="5 8" strokeLinecap="round" data-id="element-44" data-mp="88munlz4zt1x" />
      <circle cx="60" cy="74" r="42" fill="none" stroke="#A1D4FD" strokeWidth="2" opacity="0.7" data-id="element-45" data-mp="3up978pzf47o7" />

      {/* legs */}
      <path d="M52 118 v16" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-46" data-mp="3h4uh04xtwi0" />
      <path d="M68 118 l2 12 l7 4" fill="none" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-47" data-mp="r7im4pjm1tc2" />

      {/* torso */}
      <rect x="40" y="72" width="40" height="48" rx="13" fill={SKIN} stroke={INK} strokeWidth="3" data-id="element-48" data-mp="vz92pd955dbx" />
      <path d="M50 78 h20" stroke={TEAL} strokeWidth="2.6" strokeLinecap="round" data-id="element-49" data-mp="1efduwhduqu9a" />

      {/* arms crossed */}
      <path d="M40 86 L74 97" stroke={INK} strokeWidth="6.5" strokeLinecap="round" data-id="element-50" data-mp="1t407wcg0b9xc" />
      <path d="M80 86 L46 97" stroke={INK} strokeWidth="6.5" strokeLinecap="round" data-id="element-51" data-mp="1oci9nw5dbng2" />

      {/* head */}
      <circle cx="60" cy="52" r="16" fill={SKIN} stroke={INK} strokeWidth="3" data-id="element-52" data-mp="223x1msh96yz9" />
      <path d="M43 58 q-1 -26 17 -26 q18 0 17 26 q-5 -8 -6 -14 q-9 5 -23 2 q0 7 -5 12 z" fill={INK} data-id="element-53" data-mp="1x5deioqxbh5b" />
      <circle cx="54" cy="53" r="2.2" fill={INK} data-id="element-54" data-mp="2c2w57wn5w4fe" />
      <circle cx="66" cy="53" r="2.2" fill={INK} data-id="element-55" data-mp="2c0jm3g5o3o0r" />
      <path d="M63 46 q4 1 6 3" stroke={INK} strokeWidth="2.2" strokeLinecap="round" fill="none" data-id="element-56" data-mp="2739nb9we2009" />
      <path d="M55 60 q6 3 10 -2" fill="none" stroke={INK} strokeWidth="2.4" strokeLinecap="round" data-id="element-57" data-mp="hntksdcyzcjc" />

      <path d="M34 140 h52" stroke={TEAL} strokeWidth="3" strokeLinecap="round" data-id="element-58" data-mp="crlapedmq9j1" />
    </svg>;
}